module.exports = __webpack_public_path__ + "assets-customer/images/hoodies-category.png?f528d76e";